
import {defineComponent, reactive, toRefs, onMounted} from 'vue'
import {store} from "@/store";

export default defineComponent({
  setup() {
    const proxyData = reactive({
      portait: store.state.portait,
    })
    onMounted(() => {
    })
    return {
      ...toRefs(proxyData)
    }
  }
})
